// extracted by mini-css-extract-plugin
export default {"auth":"Auth_auth__jrl9b","control":"Auth_control__e76tY"};